"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  loginButton: 'Sign In',
  signupButton: 'New user? Sign Up',
  version: 'Version'
};
exports["default"] = _default;
//# sourceMappingURL=en-US.js.map
